<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">e way · Konzern Zugehörigkeit</p>

      <h2 class="presentation-page__title">e way Energy — Teil eines europäischen Bauriesen</h2>

      <p class="presentation-page__text">
        Eine PV-Anlage, die 20+ Jahre laufen muss, braucht einen Partner, der 20+ Jahre besteht.
      </p>

      <div class="presentation-page__group-cards">
        <article
          v-for="groupCard in groupCards"
          :key="groupCard.title"
          class="presentation-page__group-card"
        >
          <div
            :class="[
              'presentation-page__group-card-header',
              `presentation-page__group-card-header--${groupCard.accent}`,
            ]"
          >
            {{ groupCard.header }}
          </div>

          <div
            class="presentation-page__group-card-body presentation-page__group-card-body--detail"
          >
            <h3 class="presentation-page__group-card-title">{{ groupCard.title }}</h3>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <p class="presentation-page__group-card-text">{{ groupCard.text }}</p>

            <dl class="presentation-page__group-card-meta">
              <div
                v-for="metaItem in groupCard.meta"
                :key="metaItem.label"
                class="presentation-page__group-card-meta-row"
              >
                <dt class="presentation-page__group-card-meta-label">{{ metaItem.label }}</dt>
                <dd class="presentation-page__group-card-meta-value">{{ metaItem.value }}</dd>
              </div>
            </dl>
          </div>
        </article>
      </div>

      <p class="presentation-page__caption">
        Was das für Sie bedeutet: Garantien, die in 20 Jahren noch wirksam sind. Ein
        Service-Partner, der nicht verschwindet.
      </p>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage06',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      groupCards: [
        {
          header: 'Projektumsetzung',
          accent: 'brand-teal',
          title: 'e way Energy GmbH',
          text:
            'Ihr direkter EPC- und O&M-Partner. Plant, baut und betreibt PV-Anlagen schlüsselfertig in Deutschland.',
          meta: [
            { label: 'Sitz', value: 'Deutschland' },
            { label: 'Fokus', value: 'PV-Aufdach' },
            { label: 'Service', value: '20-Jahre O&M' },
          ],
        },
        {
          header: 'Technische Tiefe',
          accent: 'brand-secondary',
          title: 'Salvia Gebäudetechnik',
          text:
            'Muttergesellschaft. Eine der führenden Gebäudetechnik-Gruppen im deutschsprachigen Raum.',
          meta: [
            { label: 'Standorte', value: 'DE & AT' },
            { label: 'Bereiche', value: 'Elektro · TGA · Energie' },
            { label: 'Teil von', value: 'Eiffage Énergie Systèmes' },
          ],
        },
        {
          header: 'Konzern Rückgrat',
          accent: 'brand-primary',
          title: 'Eiffage-Gruppe',
          text:
            'Mehrheitseigentümer. Börsennotierter französischer Bau- und Konzessionskonzern. Erbauer u. a. des Eiffelturms (1889).',
          meta: [
            { label: 'Mitarbeiter', value: '~78.200' },
            { label: 'Umsatz 2023', value: '~21,8 Mrd. €' },
            { label: 'Position', value: 'Top-4 Europa' },
          ],
        },
      ],
    };
  },
};
</script>
